/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_file_img': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M-2-2h24v24H-2z"/><path pid="1" d="M0 0h20v20H0V0zm16.223 4H3.778C3.348 4 3 4.383 3 4.855v10.29c0 .472.348.855.778.855h12.444c.43 0 .778-.383.778-.855V4.855c0-.472-.348-.855-.777-.855zm-2.837 6.115c-.287-.343-.753-.343-1.04 0l-1.18 1.407-1.355 1.614a.242.242 0 0 1-.384 0 .37.37 0 0 1 0-.458l1.353-1.614-2.809-3.35c-.287-.342-.752-.342-1.04 0L3.875 10.46V4.923h12.25v7.56l-2.74-2.368zM12 7a1 1 0 1 0 2 0 1 1 0 0 0-2 0z" _fill="#FFB000"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_file_img.js